import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Config } from "src/app/shared/types/contract-types";
import { PopupType } from "src/app/shared/enums/popup-types";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfigService } from "src/app/shared/services/config.service";
import { UserRoles } from "src/app/shared/enums/user-roles";

@Component({
  selector: "app-config",
  templateUrl: "./config.component.html",
  standalone: false,
})
export class ConfigComponent {
  @Input() contractId!: number;
  @Input() configId!: number;

  isLoading = false;
  isEditMode = false;
  passwordVisible = false;
  userRole = UserRoles;

  config!: Config;

  editedConfig!: Config;
  configForm!: FormGroup;

  preEditState!: Config;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private configService: ConfigService,
  ) {}

  ngOnInit() {
    this.configForm = this.fb.group({
      instanceApiConnectionString: ["", Validators.required],
      authBaseUrl: ["", Validators.required],
      eTouristBaseUrl: ["", Validators.required],
      adminName: ["", Validators.required],
      adminSurname: ["", Validators.required],
      allowedOrigins: ["", Validators.required],
      authSecret: ["", Validators.required],
      authApiKey: ["", Validators.required],
    });
    this.loadData();

    this.configForm.disable();
  }

  loadData() {
    const loadSubscription = this.configService
      .getConfig(this.configId)
      .subscribe((res) => {
        loadSubscription.unsubscribe();
        this.config = res;
        this.configForm.patchValue(res);
        this.editedConfig = { ...res };
      });
  }

  changeMode() {
    this.preEditState = this.configForm.value;
    this.configForm.enable();
    this.isEditMode = true;
  }

  cancelEditMode() {
    this.isEditMode = false;
    this.configForm.disable();
    this.configForm.patchValue(this.preEditState);
  }

  onSaveConfig() {
    let message = "";
    if (this.configForm.valid) {
      this.isLoading = true;
      this.editedConfig = { ...this.editedConfig, ...this.configForm.value };

      const subscription = this.configService
        .updateConfig(this.configId, this.editedConfig)
        .subscribe({
          next: () => {
            subscription.unsubscribe();
            message = `${this.translate.instant("config_updated")}`;

            showMessage(PopupType.Success, message);
            this.isLoading = false;
            this.isEditMode = false;

            this.configForm.markAsUntouched();
            this.configForm.disable();
            this.loadData();
          },
          error: (error) => {
            // eslint-disable-next-line no-console
            console.log(error);
            subscription.unsubscribe();

            this.isLoading = false;
            showMessage(PopupType.Danger, error.message);
          },
        });
    }
    else {
      this.isLoading = false;
      this.configForm.markAllAsTouched();
      message = `${this.translate.instant("invalid_form")}`;

      showMessage(PopupType.Danger, message);
    }
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  applyChanges() {
    this.configService.applyConfig(this.configId).subscribe({
      next: () => {
        showMessage(PopupType.Success, "Config applied successfully");
        this.loadData();
      },
      error: () => {
        showMessage(PopupType.Danger, "Failed to apply config");
        this.loadData();
      },
    });
  }
}
